export default {
    loading: `正在加载验证码 ···`,
    init: `正在初始化验证码 ···`,
    click: `点击按钮进行验证`,
    checking: `智能检测中 ···`,
    pass: `通过验证`,
    tip: `错误提示`,
    error: {
        try: `已连续错误达 {num} 次，请稍候再试`,
        init: `初始化接口有误，请稍候再试`
    },
    move: `请移动滑块，完成验证`,
    drag: `拖动左边滑块完成上方拼图`,
    dragging: `拖动滑块将悬浮图像正确拼合`,
    close: `关闭验证`,
    refresh: `刷新验证`,
    feedback: `帮助反馈`,
    provide: `「 makeit.vip 」提供技术支持`,
    success: `{take}s速度完成图片拼合验证`,
    flatten: `拖动滑块拼合图片`,
    verify: `就能验证成功哦`
}
